/* @flow */
/* eslint-env es6,browser */

/**
 * Provides interface for all renderer class for ad servers
 *
 * @class
 */

export default class _adrenderbase {
  _doc: Document;
  _win: window;
  _name: string;
  _as: string;
  constructor() {
    this._doc = document;
    this._win = window;
    this._name = this._as = '';
  }

  /**
   * get ad server name this object is associated with
   *
   * @returns {string} - ad server name
   */
  getAS(): string {
    return this._as;
  }

  /**
   * render the given ad
   *
   * @param {*} adInfoObj adInfo object
   * @param {string} containerID ID to render into
   */
  // eslint-disable-next-line no-unused-vars
  renderAd(adInfoObj: adInfo, containerID: string): boolean {
    return false;
  }
}
